<script>
export default {
  methods: {
    getColumns (row, activeModule) {
      if (row && row.items && row.items.length && activeModule && activeModule.items) {
        if (activeModule.grid) {
          return Math.ceil(row.items.length / activeModule.items.length)
        } else {
          return activeModule.items.length
        }
      }
      return 1
    },
    getItems (getColumnIndex, activeModule) {
      if (!activeModule.grid) {
        return [{
          index: getColumnIndex,
          type: activeModule.items[getColumnIndex]
        }]
      }

      const items = []
      for (let index = 0; index < activeModule.items.length; index++) {
        items.push({
          index: index + (getColumnIndex * activeModule.items.length),
          type: activeModule.items[index]
        })
      }
      return items
    }
  }
}
</script>
